export const LoadingStateOptions = {
	LOADING_INITIAL: 'LOADING_INITIAL',
	LOADING_SET_VARIABLES: 'LOADING_SET_VARIABLES',
	LOADING_NEXT_PAGE: 'LOADING_NEXT_PAGE',
	READY: 'READY',
	HAS_ERROR: 'HAS_ERROR',
	UNMAPPED: 'UNMAPPED',
} as const;

export type LoadingState = keyof typeof LoadingStateOptions;

export type ServiceQueryResultWithStatus<T> = {
	loadingState: LoadingState;
	error?: Error;
	data?: T;
};

export type ServiceQueryResult<T> = {
	loading: boolean;
	error?: Error;
	data?: T;
};

export type ServiceQueryResultWithFetch<
	T,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	V extends (...args: any[]) => Promise<any> = () => Promise<void>,
> = ServiceQueryResult<T> & {
	fetch: V;
};

export type ServiceMutationResult<T> = {
	loading: boolean;
	error?: Error;
	data?: T;
	called: boolean;
};
